import React from 'react';

export default function LoadingOverlay({ message }) {
    return (
        <div className="loading-overlay">
            <div className="loading-spinner"></div>
            <p>{message}</p>
        </div>
    );
}
